import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import Icon from '../../../components/AppIcon';

const PatientSatisfactionCard = ({ data, overallScore }) => {
  const COLORS = ['var(--color-success)', 'var(--color-primary)', 'var(--color-warning)', 'var(--color-error)'];

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-xl md:text-2xl font-semibold text-foreground">Patient Satisfaction</h2>
          <p className="text-sm text-muted-foreground mt-1">Monthly feedback analysis</p>
        </div>
        <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-success/10">
          <Icon name="Star" size={20} color="var(--color-success)" />
          <span className="text-2xl font-bold text-success">{overallScore}</span>
          <span className="text-sm text-muted-foreground">/5.0</span>
        </div>
      </div>
      <div className="w-full h-64 md:h-80" aria-label="Patient Satisfaction Pie Chart">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              labelLine={false}
              label={({ name, percent }) => `${name}: ${(percent * 100)?.toFixed(0)}%`}
              outerRadius={80}
              fill="#8884d8"
              dataKey="value"
            >
              {data?.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS?.[index % COLORS?.length]} />
              ))}
            </Pie>
            <Tooltip 
              contentStyle={{ 
                backgroundColor: 'var(--color-card)',
                border: '1px solid var(--color-border)',
                borderRadius: '8px'
              }}
            />
            <Legend 
              wrapperStyle={{ fontSize: '12px' }}
              verticalAlign="bottom"
            />
          </PieChart>
        </ResponsiveContainer>
      </div>
      <div className="grid grid-cols-2 gap-4 mt-6">
        <div className="p-4 rounded-lg bg-muted/30">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="ThumbsUp" size={16} color="var(--color-success)" />
            <span className="text-xs font-medium text-muted-foreground">Positive Feedback</span>
          </div>
          <span className="text-xl md:text-2xl font-bold text-foreground">87%</span>
        </div>
        <div className="p-4 rounded-lg bg-muted/30">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="MessageSquare" size={16} color="var(--color-primary)" />
            <span className="text-xs font-medium text-muted-foreground">Total Responses</span>
          </div>
          <span className="text-xl md:text-2xl font-bold text-foreground">1,247</span>
        </div>
      </div>
    </div>
  );
};

export default PatientSatisfactionCard;